module.exports = __webpack_public_path__ + "img/key.efc320bf.svg";